// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"064423de","455":"106f0086","977":"240addac"}[chunkId] + ".chunk.js";
};